/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AwsServiceUploadFilePresignResponse } from "./AwsServiceUploadFilePresignResponse";

export type AwsServiceUploadFilePresignResponseApiRespoonse = {
  data?: AwsServiceUploadFilePresignResponse;
  status?: AwsServiceUploadFilePresignResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AwsServiceUploadFilePresignResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
